import { getRespondentOrigin } from "src/shared/helpers";
import { useAppSelector } from "src/store";
import { selectFormState } from "src/store/form/form";

export default function useLink() {
  const customId = useAppSelector((state) => selectFormState(state).customID);
  return `${getRespondentOrigin()}/${customId}`;
}
